// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rowButton: {
      marginTop: theme.spacing(3),
      '& button': {
        width: '9rem',
        padding: '4px 2.125rem',
        textTransform: 'none',
        background: '#0094FF',
        borderRadius: '1rem',
        '&:hover': {
          background: '#0094FF',
          filter: 'brightness(0.9)',
        },
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    defaultStyle: {},
    input: {
      '& div': {
        display: 'flex',
        alignItems: 'center',
        height: '2.4rem',
        borderRadius: '0.75rem',
        width: '100%',
        '& fieldset': {
          border: '2px solid #E1E8ED',
        },
        '& input': {
          padding: '0.375rem 1rem',
          marginRight: '0.5rem',
        },
        '& svg path': {
          fill: '#E1E8ED',
        },
      },
    },
    subtitle: {
      color: '#00CAD7',
      padding: '0.25rem 0.75rem',
    },
    inputPhone: {
      '& div': {
        display: 'flex',
        alignItems: 'center',
        height: '2.4rem',
        borderRadius: '0.75rem',
        marginRight: '0px',
        '& fieldset': {
          border: '2px solid #E1E8ED',
        },
        '& input': {
          padding: '0.375rem 1rem',
          marginRight: '0px',
          // marginRight: '0.5rem',
        },
        '& svg path': {
          fill: '#E1E8ED',
        },
      },
    },
  }),
);

export default useStyles;
